import { SourceSystem } from '@atlassian/cssxp-typescommon';
import { BillingDocWithLineItems } from '@atlassian/cssxp-types-billing';
import * as React from 'react';
import BillingDocContactDetailBlock from './billing-doc-contact-detail';
import BillingShippingDocDetailBlock from './billing-shipping-doc-detail';

interface Props {
  additionalContent: React.ReactNode;
  billingDoc?: BillingDocWithLineItems;
}

// Common Billing Doc Details: Contacts and Dates
const BillingDocDetails = ({ additionalContent, billingDoc }: Props) => {
  // const { billingDoc } = useSelector(billingDocDetailsState, shallowEqual);

  return (
    <div data-testid="billing-doc-details" className="billing-doc-details">
      {billingDoc?.sourceSystem === SourceSystem.CCP ? (
        <>
          <div style={{ marginRight: '32px' }}>
            <h4>Billing Details</h4>
            <BillingShippingDocDetailBlock contact={billingDoc?.billTo} block={'billTo'} />
          </div>

          <div style={{ marginRight: '32px' }}>
            <h4>Shipping Details</h4>
            <BillingShippingDocDetailBlock contact={billingDoc?.shipTo} block={'shipTo'} />
          </div>
        </>
      ) : (
        <>
          {billingDoc && (
            <div data-testid="billing-contact" style={{ marginRight: '32px' }}>
              <h4>Billing contact</h4>
              <BillingDocContactDetailBlock contact={billingDoc?.billTo} />
            </div>
          )}
          {billingDoc && (
            <div data-testid="technical-contact" style={{ marginRight: '32px' }}>
              <h4>Technical contact</h4>
              <BillingDocContactDetailBlock contact={billingDoc?.shipTo} />
            </div>
          )}
        </>
      )}
      <div data-testid="additional-content" style={{ display: 'flex', flex: '1' }}>
        {additionalContent}
      </div>
    </div>
  );
};

export default BillingDocDetails;
